<template>
	<div class="headers" :class="{ bg: type==1, bg2: type==2 }">
		<div class="line" v-if="type==1">
			<div class="w1228 df war hao">
				<div class="btn shopcar" @click="tapShopcar">购物车</div>
				<div class="btn collect" @click="tapCollect">收藏</div>
				<div class="user df hao" v-if="$store.state.userinfo.has">
					<img :src="$store.state.userinfo.head" alt="">
					你好，{{$store.state.userinfo.name}}
					<div class="float">
						<div class="area">
							<div class="nav nav-1" @click="tapFloat(1)">个人资料</div>
							<div class="nav nav-2" @click="tapFloat(2)">账号认证</div>
							<div class="nav nav-3" @click="tapFloat(3)">账号安全</div>
							<div class="nav nav-4" @click="tapFloat(4)">我的订单</div>
							<div class="nav nav-5" @click="tapFloat(5)">我的收藏</div>
							<div class="nav nav-6" @click="tapFloat(6)">消息中心</div>
							<div class="nav nav-7" @click="tapFloat(7)">退出登录</div>
						</div>
					</div>
				</div>
				<template v-else>
					<div class="btn" @click="tapBtn(1)">注册</div>
					<div class="btn" @click="tapBtn(2)">登录</div>
				</template>
			</div>
		</div>
		<div class="line2 w1228 df hao jcb" v-if="type==1">
			<div class="logo" @click="$api.toPage('index')"></div>
			<div class="search df">
				<input type="text" class="flex" placeholder="输入关键词进行搜索" v-model="keyword">
				<div class="btn" @click="tapSearch"></div>
			</div>
		</div>
		<div class="line3 w1720 df hao jcb" v-if="type==2">
			<div class="logo2" @click="$api.toPage('index')"></div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'headers',
	props: {
		type: {
			default: 1, // [1 全站通用带搜索头部] [2 注册/登录专用简约头部]
		},
	},
	data () {
		return {
			keyword: '',
		}
	},
	methods: {
		tapShopcar(){
			try{
				this.$parent.$refs.shopcarsRef.showShopCar()
			}catch(e){}
		},
		tapCollect(){
			// let url = window.location.href
			// let title = document.title
			// if(window.sidebar){ // Mozilla Firefox bookmark
			// 	window.sidebar.addPanel(title, url, '');
			// }else if(window.external){ // IE Favorite
			// 	try{
			// 		window.external.addFavorite(url, title);
			// 	}catch(e){
			// 		alert('由于浏览器功能限制，请按 Ctrl+D 手动收藏！');
			// 	}
			// }else if(window.opera && window.print){ // Opera Hotlist
			// 	this.title = title;
			// 	// return true;
			// }else{ // webkit bookmark
			// 	// alert('Press ' + (navigator.userAgent.toLowerCase().indexOf('mac') != -1 ? 'Command/Cmd' : 'CTRL') + ' + D to bookmark this page.');
			// }
			this.$api.toPage('my/collect')
		},
		tapFloat(type){
			if(type==1){ // 个人资料
				this.$api.toPage('my/info')
			}else if(type==2){ // 账号认证
				this.$api.toPage('my/account')
			}else if(type==3){ // 账号安全
				this.$api.toPage('my/safe')
			}else if(type==4){ // 我的订单
				this.$api.toPage('my/order')
			}else if(type==5){ // 我的收藏
				this.$api.toPage('my/collect')
			}else if(type==6){ // 消息中心
				this.$api.toPage('my/notice')
			}else if(type==7){ // 退出登录
				this.$ajax.unlogin({
					try: true,
				})
				window.localStorage.removeItem('usertoken')
				// this.$api.toPage('login')
				this.$store.commit('setUserinfo',{})
			}
		},
		tapBtn(type){
			if(type==1){ // 注册
				this.$api.toPage('regit')
			}else if(type==2){ // 登录
				this.$api.toPage('login')
			}
		},
		tapSearch(){
			if(this.keyword==''){
				this.$alert({
					title: '请输入搜索关键词',
				}).then(()=>{})
				return
			}
			this.$api.toPage('search',{
				keyword: this.keyword,
			});
		},
	},
}
</script>

<style lang="less" scoped>
	.headers{
		position: relative;
		z-index: 999;
		&.bg{
			background: #fafcf3;
		}
		&.bg2{
			background: #009b73;
		}
		.line{
			position: fixed;
			top: 0;
			left: 0;
			right: 0;
			z-index: 999;
			height: 32rpx;
			background: #fafcf3;
			.btn{
				font-family: PingFang SC, PingFang SC;
				font-weight: 400;
				font-size: 14px;
				color: #7F7F7F;
				line-height: 32px;
				margin: 0 12px 0 13px;
				position: relative;
				&:not(:first-child)::before{
					content: '';
					position: absolute;
					left: -13px;
					top: 50%;
					width: 1px;
					height: 12px;
					background: #e6e6e6;
					margin-top: -6px;
				}
				&.shopcar{
					padding-left: 28px;
					background: url(../../assets/img/shopcar.png) left center / 18px auto no-repeat;
				}
				&.collect{
					padding-left: 28px;
					background: url(../../assets/img/collect.png) left center / 18px auto no-repeat;
				}
			}
			.user{
				font-family: PingFang SC, PingFang SC;
				font-weight: 400;
				font-size: 12px;
				color: #111212;
				line-height: 14px;
				padding-right: 26px;
				background: url(../../assets/img/arrow.png) right center / 18px auto no-repeat;
				margin-left: 24px;
				height: 32px;
				cursor: pointer;
				&:hover{
					background-image: url(../../assets/img/arrow2.png);
				}
				img{
					width: 28px;
					height: 28px;
					border-radius: 50%;
					border: 1px solid #009B73;
					object-fit: cover;
					margin-right: 8px;
				}
				.float{
					position: fixed;
					z-index: 999;
					padding-top: 32px;
					top: 0;
					left: 50%;
					margin-left: 614px;
					transform: translateX(-100%);
					opacity: 0;
					pointer-events: none;
					transition: all 0.2s ease-in-out;
					.area{
						min-width: 136px;
						background: #FFFFFF;
						box-shadow: 0px 3px 12px -2px rgba(10,39,54,0.3);
						border-radius: 4px;
						padding: 12px 16px;
					}
					.nav{
						font-family: PingFang SC, PingFang SC;
						font-weight: 500;
						font-size: 14px;
						color: #4C4C4C;
						line-height: 22px;
						text-align: left;
						padding: 8px 0 8px 24px;
						&:not(:first-child){
							margin-top: 4px;
						}
						&:hover{
							color: #E73363;
						}
						&.nav-1{
							background: url(../../assets/img/float/1.png) left center / 16px auto no-repeat;
						}
						&:hover.nav-1{
							background: url(../../assets/img/float/1h.png) left center / 16px auto no-repeat;
						}
						&.nav-2{
							background: url(../../assets/img/float/2.png) left center / 16px auto no-repeat;
						}
						&:hover.nav-2{
							background: url(../../assets/img/float/2h.png) left center / 16px auto no-repeat;
						}
						&.nav-3{
							background: url(../../assets/img/float/3.png) left center / 16px auto no-repeat;
						}
						&:hover.nav-3{
							background: url(../../assets/img/float/3h.png) left center / 16px auto no-repeat;
						}
						&.nav-4{
							background: url(../../assets/img/float/4.png) left center / 16px auto no-repeat;
						}
						&:hover.nav-4{
							background: url(../../assets/img/float/4h.png) left center / 16px auto no-repeat;
						}
						&.nav-5{
							background: url(../../assets/img/float/5.png) left center / 16px auto no-repeat;
						}
						&:hover.nav-5{
							background: url(../../assets/img/float/5h.png) left center / 16px auto no-repeat;
						}
						&.nav-6{
							background: url(../../assets/img/float/6.png) left center / 16px auto no-repeat;
						}
						&:hover.nav-6{
							background: url(../../assets/img/float/6h.png) left center / 16px auto no-repeat;
						}
					}
				}
				&:hover .float{
					margin-top: 8px;
					pointer-events: auto;
					opacity: 1;
				}
			}
		}
		.line2{
			height: 144px;
			padding-top: 32px;
			.logo{
				width: 314px;
				height: 66px;
				background: url(../../assets/img/logo.png) center center / 100% auto no-repeat;
				margin-bottom: 16px;
				cursor: pointer;
			}
			.search{
				input{
					border:2px solid #009b73;
					padding: 0 12px;
					font-family: PingFang SC, PingFang SC;
					font-weight: 400;
					font-size: 14px;
					color: #333;
					line-height: 16px;
					width: 400px;
					height: 36px;
					&::placeholder {
						color: #7f7f7f;
					}
				}
			}
			.btn{
				width: 52px;
				height: 36px;
				background: #009b73 url(../../assets/img/search.png) center center / 24px auto no-repeat;
			}
		}
		.line3{
			height: 92px;
			.logo2{
				width: 314px;
				height: 66px;
				background: url(../../assets/img/logo2.png) center center / 100% auto no-repeat;
				cursor: pointer;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/headers/headers.vue